import { createActions, createAction } from 'redux-actions';
import { request } from '../../services';

const {
  assignedFiltersListRequest,
  assignedFiltersListSuccess,
  assignedFiltersListFailure,
} = createActions({
  ASSIGNED_FILTERS_LIST_SUCCESS: [
    json => json.assigned_filters,
    json => json.meta,
  ],
}, 'ASSIGNED_FILTERS_LIST_REQUEST', 'ASSIGNED_FILTERS_LIST_FAILURE');

export const updateAssignedFilterPosition = createAction(
  'UPDATE_ASSIGNED_FILTER_POSITION',
  (oldPosition, newPosition) => ({ oldPosition, newPosition }),
);

export const requestAssignedFilters = () => (dispatch) => {
  dispatch(assignedFiltersListRequest());
  return request('assigned_filters')
    .then(({ json }) => {
      const mapped = json;
      mapped.assigned_filters = json.assigned_filters.map(e => ({
        ...e, type: 'assigned',
      }));
      return mapped;
    })
    .then(json => dispatch(assignedFiltersListSuccess(json)))
    .catch(error => dispatch(assignedFiltersListFailure(error)));
};

const {
  assignedFilterCountRequest,
  assignedFilterCountSuccess,
  assignedFilterCountFailure,
} = createActions({
  ASSIGNED_FILTER_COUNT_SUCCESS: json => json,
}, 'ASSIGNED_FILTER_COUNT_REQUEST', 'ASSIGNED_FILTER_COUNT_FAILURE');

export const requestFilterCount = filterId => (dispatch) => {
  dispatch(assignedFilterCountRequest());
  return request(`assigned_filters/${filterId}`)
    .then(({ json }) => dispatch(assignedFilterCountSuccess(json)))
  .catch(error => dispatch(assignedFilterCountFailure(error)));
};

const {
  assignedFilterCreateRequest,
  assignedFilterCreateSuccess,
  assignedFilterCreateFailure,
} = createActions({
  ASSIGNED_FILTER_CREATE_SUCCESS: json => json.assigned_filter,
},
  'ASSIGNED_FILTER_CREATE_REQUEST',
  'ASSIGNED_FILTER_CREATE_FAILURE',
);

export const createAssignedFilter = assignedFilter => (dispatch) => {
  dispatch(assignedFilterCreateRequest());
  return request('assigned_filters/', {
    method: 'POST', body: { assigned_filter: assignedFilter },
  })
  .then(({ json }) => dispatch(assignedFilterCreateSuccess(json)))
  .catch(error => dispatch(assignedFilterCreateFailure(error)));
};

const {
  assignedFilterUpdateRequest,
  assignedFilterUpdateSuccess,
  assignedFilterUpdateFailure,
} = createActions({
  ASSIGNED_FILTER_UPDATE_SUCCESS: json => json.assigned_filter,
}, 'ASSIGNED_FILTER_UPDATE_REQUEST', 'ASSIGNED_FILTER_UPDATE_FAILURE');

export const updateAssignedFilter = (assignedFilter, assignedFilterId) => (dispatch) => {
  dispatch(assignedFilterUpdateRequest());
  return request(`assigned_filters/${assignedFilterId}`, {
    method: 'PUT', body: { assigned_filter: assignedFilter },
  })
  .then(({ json }) => dispatch(assignedFilterUpdateSuccess(json)))
  .catch(error => dispatch(assignedFilterUpdateFailure(error)));
};

const {
  assignedFilterDeleteRequest,
  assignedFilterDeleteSuccess,
  assignedFilterDeleteFailure,
} = createActions({
  ASSIGNED_FILTER_DELETE_SUCCESS: assignedFilterId => ({ assignedFilterId }),
}, 'ASSIGNED_FILTER_DELETE_REQUEST', 'ASSIGNED_FILTER_DELETE_FAILURE');


export const deleteAssignedFilter = assignedFilterId => (dispatch) => {
  dispatch(assignedFilterDeleteRequest());
  return request(`assigned_filters/${assignedFilterId}`, { method: 'DELETE' })
    .then(() => dispatch(assignedFilterDeleteSuccess(assignedFilterId)))
    .catch(error => dispatch(assignedFilterDeleteFailure(error)));
};



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/assigned_filters.js